import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginBaseComponent } from './component/login/login-base/login-base.component';
import { ComponentComponent } from './component/component.component';
import { AuthGuard } from './guard/auth.guard';
import { AccessGuard } from './guard/access.guard';
import { DashboardComponent } from './component/dashboard/dashboard.component';
import { DerivativeBaseComponent } from './component/derivative-base/derivative-base.component';
import { RegisterUserComponent } from './component/login/register-user/register-user.component';
import { OtpComponent } from './component/login/otp/otp.component';
import { RegisterBaseComponent } from './component/login/register-base/register-base.component';
import { MenuMappingComponent } from './component/login/menu-mapping/menu-mapping.component';
import { AdminComponent } from './component/admin/admin.component';
import { NewUserApprovalComponent } from './component/admin/new-user-approval/new-user-approval.component';
import { ChangePasswordComponent } from './component/login/change-password/change-password.component';
import { SmallPageLayoutComponent } from './component/small-page-layout/small-page-layout.component';
import { ProfileComponent } from './component/profile/profile.component';
import { ContactComponent } from './component/login/contact/contact.component';
import { AccessDetailsComponent } from './component/admin/access-details/access-details.component';
import { UserListComponent } from './component/admin/user-list/user-list.component';
import { PNoteRoutingModule } from './component/derivative-base/pnote/pnote-routing.module';
import { AddUserComponent } from './component/admin/add-user/add-user.component';
import { RegisterMasterComponent } from './component/login/register-master/register-master.component';
import { MenuGuard } from './guard/menu.guard';
import { SubmenuGuard } from './guard/submenu.guard';
import { ParameterMasterModule } from './component/admin/parameter-master/parameter-master.module';
import { Subscriber } from 'rxjs';
import { HolidayMasterComponent } from './component/admin/parameter-master/holiday-master/holiday-master.component';


const routes: Routes = [{
  path: 'login', component: LoginBaseComponent, loadChildren: () => import('./component/login/login.module').then(m => m.LoginModule),
},
{
  path: 'registeruser', component: RegisterBaseComponent, children: [{ path: '', component: RegisterMasterComponent }, { path: 'register', component: RegisterUserComponent }, { path: 'menuMapping', component: MenuMappingComponent }]
},
{
  path: '', component: ComponentComponent,
  children: [
    { path: '', component: DashboardComponent },
    // { path: 'changepassword', component: SmallPageLayoutComponent, children: [{ path: '', component: ChangePasswordComponent }] },
    // { path: 'profile', component: SmallPageLayoutComponent, children: [{ path: '', component: ProfileComponent }] },
    { path: 'contact', component: SmallPageLayoutComponent, children: [{ path: '', component: ContactComponent }] },
    { path: 'creditDerivatives', component: DerivativeBaseComponent, loadChildren: () => import('./component/derivative-base/credit-derivatives/credit-derivatives.module').then(m => m.CreditDerivativesModule) },
    { path: 'forexDerivatives', component: DerivativeBaseComponent, loadChildren: () => import('./component/derivative-base/forex-derivatives/forex-derivatives.module').then(m => m.ForexDerivativesModule) },
    { path: 'rateDerivatives', component: DerivativeBaseComponent, loadChildren: () => import('./component/derivative-base/rate-derivatives/rate-derivatives.module').then(m => m.RateDerivativesModule) },
    { path: 'commonActivity', component: DerivativeBaseComponent, loadChildren: () => import('./component/derivative-base/common-activity/common-activity.module').then(m => m.CommonActivityModule) },
    { path: 'securities', canActivate: [MenuGuard,AccessGuard], component: DerivativeBaseComponent, loadChildren: () => import('./component/derivative-base/pnote/pnote-routing.module').then(m => m.PNoteRoutingModule) },
    { path: 'sovereignGreenBond', component: DerivativeBaseComponent, loadChildren: () => import('./component/srgb/sgrb-routing.module').then(m => m.SgrbRoutingModule) },
    { path: 'otcTrade', component: DerivativeBaseComponent, loadChildren: () => import('./component/trade-report/trade-report.module').then(m => m.TradeReportModule) },

    {
      path: 'admin', canActivate: [MenuGuard,AccessGuard], component: DerivativeBaseComponent, 
      children: [
        { path: 'userApproval', canDeactivate: [SubmenuGuard], 
            children: [{ path: '', canDeactivate: [SubmenuGuard], component: NewUserApprovalComponent }, 
                       { path: 'adminApproval', canDeactivate: [SubmenuGuard], component: RegisterUserComponent }] },
        { path: 'userList', canDeactivate: [SubmenuGuard], 
            children: [{ path: '', canDeactivate: [SubmenuGuard], component: UserListComponent }, 
                      { path: 'accessMapping', canDeactivate: [SubmenuGuard], component: AccessDetailsComponent }, 
                      { path: 'add-user', canDeactivate: [SubmenuGuard], component: AddUserComponent }] },
        { path: 'parameterMaster', canDeactivate: [SubmenuGuard],
          children: [{ path: '', canDeactivate: [SubmenuGuard], component: ParameterMasterModule },
        {path: 'holiday-master',canDeactivate: [SubmenuGuard],component: HolidayMasterComponent }
        ]
      }]
    },
    { path: 'settings', component: SmallPageLayoutComponent, children: [{ path: '', component: ProfileComponent }, { path: 'accessMapping', component: AccessDetailsComponent }, { path: 'changepassword', component: ChangePasswordComponent }] }
  ]
},
{ path: '**', redirectTo: '', pathMatch: 'full' }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
  providers: [AuthGuard, AccessGuard]
})
export class AppRoutingModule { }
